export const getHttpErrorStatus = (error: unknown): number | undefined => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as { response?: { status?: number } }).response?.status ===
      'number'
  ) {
    return (error as { response: { status: number } }).response.status;
  }

  return undefined;
};

export const isNotFoundError = (error: unknown): boolean =>
  getHttpErrorStatus(error) === 404;
